import '../assets/NcCheckboxRadioSwitch-BzAGGne9.css';
import { r as register } from "./_l10n-JYjUKekn.mjs";
register();
